import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { TFunction } from "i18next";
import TableComponent from 'components/Table';
import React, { FC } from "react";
import { Link, useHistory } from "react-router-dom";
import { OrderProperty } from "types/order";
import { formatMoney } from "utils/helpers";
import { useTaxesAndProrations } from "./hooks";

const useStyles = makeStyles((theme: any) => ({
  container: { marginTop: theme.spacing(2), marginBottom: theme.spacing(2) },
  primarycolorfonts: {
    fontWeight: 500,
    color: theme.palette.tab.offselected,
  },
  placeholderText: {
    color: theme.palette.tab.offselected,
    fontWeight: 500,
    textAlign: 'center',
    marginTop: theme.spacing(5),
  },
}));

type Props = {
  t: TFunction,
  orderId: string,
  selectedProperty: OrderProperty,
}

export const TaxesAndProrations: FC<Props> = ({
  t,
  orderId,
  selectedProperty
}) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    prorations,
    isProrationsLoading
  } = useTaxesAndProrations({
    orderId,
    selectedProperty
  });

  return (
    <Grid item container>
      <Typography variant="h6" className={classes.primarycolorfonts}>
        {t('taxesAndProrations:taxes-and-prorations')}
      </Typography>
      {prorations.length > 0 && (
        <TableComponent
          disabledBorderLeft
          cellAlignment="left"
          columns={{
            actions: {
              header: { title: t('orders:actionsLabel'), align: 'center', width: '80px' },
              renderer: ({ row }) => (
                <Box display="flex" justifyContent="center">
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => history.push(`/orders/details/${orderId}/taxes-and-prorations`)}
                    size="large"
                  >
                    <FontAwesomeIcon icon="external-link-alt" size="xs" />
                  </IconButton>
                </Box>
              ),
            },
            numer: {
              header: { title: t('common:description'), align: 'left', width: 'auto' },
              renderer: ({ row }) => (
                <Link to={`/orders/details/${orderId}/taxes-and-prorations`}>
                  {row.description}
                </Link>
              ),
            },
            loanAmount: {
              header: { title: t('orders:prorated-amount'), align: 'left' },
              // eslint-disable-next-line react/no-unused-prop-types
              renderer: ({ row }) => {
                return <>{formatMoney(row.amount)}</>;
              },
            },
          }}
          dataSet={prorations}
        />
      )}
      {(!isProrationsLoading && prorations.length === 0) && (
        <Typography className={classes.placeholderText}>{t('orders:noMortgageMessage')}</Typography>
      )}
    </Grid>
  );
};
